import React from "react";
import { Router, Switch, Route } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import PageHome from "containers/PageHome/PageHome";
import Page404 from "containers/Page404/Page404";
import ListingStayPage from "containers/ListingStayPage/ListingStayPage";
import ListingStayMapPage from "containers/ListingStayPage/ListingStayMapPage";
import ListingStayDetailPage from "containers/ListingDetailPage/ListingStayDetailPage";
import ListingCarPage from "containers/ListingCarPage/ListingCarPage";
import ListingCarMapPage from "containers/ListingCarPage/ListingCarMapPage";
import ListingCarDetailPage from "containers/ListingDetailPage/ListingCarDetailPage";
import CheckOutPage from "containers/CheckOutPage/CheckOutPage";
import PayPage from "containers/PayPage/PayPage";
import AccountPage from "containers/AccountPage/AccountPage";
import AccountPass from "containers/AccountPage/AccountPass";
import PageContact from "containers/PageContact/PageContact";
import PageAbout from "containers/PageAbout/PageAbout";
import PageSignUp from "containers/PageSignUp/PageSignUp";
import PageLogin from "containers/PageLogin/PageLogin";
import ListingRealEstateMapPage from "containers/ListingRealEstatePage/ListingRealEstateMapPage";
import ListingRealEstatePage from "containers/ListingRealEstatePage/ListingRealEstatePage";
import SiteHeader from "containers/SiteHeader";
import FooterNav from "components/FooterNav";
import useWindowSize from "hooks/useWindowResize";
import PageSearch from "containers/PageSearch/PageSearch";
import ProtectedRoute from "components/Authprovider/ProtectedRoute";
import { AuthProvider } from "components/Authprovider/Auth";
import CheckOutApp from "containers/CheckOutPage/CheckOutApp";
import history from "hooks/history";
import BookingsPage from "containers/AccountPage/BookingsPage";

export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  { path: "/#", exact: true, component: PageHome },
  { path: "/home-1-header-2", exact: true, component: PageHome },
  //
  { path: "/listing-stay", component: ListingStayPage },
  { path: "/listing-stay-map", component: ListingStayMapPage },
  { path: "/listing-stay-detail/:id", component: ListingStayDetailPage, protectedRoute: true},
  //

  //
  { path: "/listing-real-estate-map", component: ListingRealEstateMapPage },
  { path: "/listing-real-estate", component: ListingRealEstatePage },
  //
  { path: "/checkout/:id", component: CheckOutPage },
  { path: "/checkout-app/:id", component: CheckOutApp },
  { path: "/pay-done", component: PayPage },
  //
 
  { path: "/account", component: AccountPage, protectedRoute: true },
  { path: "/bookings", component: BookingsPage, protectedRoute: true },
  { path: "/account-password", component: AccountPass,protectedRoute: true },
 
  //
  { path: "/contact", component: PageContact },
  { path: "/about", component: PageAbout },
  { path: "/signup", component: PageSignUp },
  { path: "/login", component: PageLogin },
  //
  { path: "/search-page/:query", component: PageSearch },
];

const Routes = () => {
  const WIN_WIDTH = useWindowSize().width || window.innerWidth;
  
  return (
          <Router history={history}>
            <AuthProvider>
              <ScrollToTop />
              <SiteHeader />

              <Switch>
                
                  {pages.map(({ component, path, exact ,protectedRoute}) => {
                    if(protectedRoute){
                      return (
                        <ProtectedRoute
                          key={path}
                          component={component}
                          exact={!!exact}
                          path={path}
                        />
                      );
                    }
                    return (
                      <Route
                        key={path}
                        component={component}
                        exact={!!exact}
                        path={path}
                      />
                    );
                  })}
                  <Route component={Page404} />
                
              </Switch>

              {WIN_WIDTH < 768 && <FooterNav />}
              <Footer />
            </AuthProvider>
          </Router>
  );
};

export default Routes;
